module.exports = __webpack_public_path__ + "static/media/water_500_detail_03.05d21afc.jpg";